import styled from 'styled-components';

import t from '../../locations/translations';
import ImageSlider from '../../shared/sliders/imageSlider/image.slider';
import { Container } from '../../shared/styledComponents';
import { H1, H2 } from '../../shared/typography';
import P3 from '../../shared/typography/Text/Paragraph/P3/P3';
import { ThemeType } from '../../themeStyled';
import LocalImagesLoader from '../../utils/localImagesLoader';

const AboutUsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem;
	text-align: center;
`;

const TitleWrapper = styled.div`
	display: flex;

	align-items: center;
`;

const TextWrapper = styled.div`
	display: flex;
	gap: 1.6rem; /* Odstup medzi textom a obrázkom */
	align-items: center;
	padding: 20px 0;

	img {
		@media (max-width: ${({ theme }: { theme: ThemeType }) => theme.breakpoints.md}) {
			display: none;
		}
		flex: 0 0 auto; /* Obrázok má pevné rozmery */
		max-width: 33%; /* Maximálna šírka obrázka */
		height: auto; /* Zachovanie pomeru strán obrázka */
		border-radius: 8px; /* Zaoblenie okrajov */
	}

	p {
		flex: 1 1 auto; /* Text zaberá zvyšný priestor */
		line-height: 1.6; /* Zlepšenie čitateľnosti textu */
	}
`;

const TextP = styled.div`
	margin: 0; /* Odstránenie predvoleného odsadenia */

	p {
		padding-bottom: 16px;
	}
`;

const SectionWrapper = styled.div<{ textAlign?: string }>`
	text-align: ${({ textAlign }) => textAlign || 'center'};

	@media (max-width: ${({ theme }: { theme: ThemeType }) => theme.breakpoints.md}) {
		text-align: center;
	}

	h1,
	h2 {
		text-align: center;
		padding: 1rem 0;
	}
`;

const AboutUs = () => {
	return (
		<Container>
			<AboutUsWrapper>
				<SectionWrapper>
					<H1>{t('aboutUs.heading.story')}</H1>
					<TitleWrapper>
						<P3>{t('aboutUs.paragraph.formation')}</P3>
					</TitleWrapper>
					<ImageSlider basePath={'ABOUT_US_HISTORY'} />
				</SectionWrapper>

				<SectionWrapper textAlign='right'>
					<H2>{t('aboutUs.heading.distribution')}</H2>
					<TextWrapper>
						<P3>{t('aboutUs.paragraph.distribution')}</P3>
						<LocalImagesLoader image={'aboutUs_distribution.jpg'} path={'aboutUs'} />
					</TextWrapper>
					<div>
						<ImageSlider basePath={'ABOUT_US_DISTRIBUTION'} />
					</div>
				</SectionWrapper>

				<SectionWrapper textAlign='left'>
					<H2>{t('aboutUs.heading.farm')}</H2>
					<TextWrapper>
						<LocalImagesLoader image={'aboutUs_farm.jpg'} path={'aboutUs'} />
						<TextP>
							<P3>{t('aboutUs.paragraph.farm_1')}</P3>
							<P3>{t('aboutUs.paragraph.farm_2')}</P3>
						</TextP>
					</TextWrapper>
					<ImageSlider basePath={'ABOUT_US_FARM'} width={250} />
				</SectionWrapper>

				<SectionWrapper textAlign='right'>
					<H2>{t('aboutUs.heading.production')}</H2>
					<TextWrapper>
						<P3>{t('aboutUs.paragraph.production')}</P3>
						<LocalImagesLoader image={'aboutUs_p_1.jpg'} path={'aboutUs'} />
					</TextWrapper>
					<ImageSlider basePath={'ABOUT_US_PRODUCTION'} width={200} />
				</SectionWrapper>

				<ImageSlider basePath={'ABOUT_US_PRODUCTS'} opposite />
			</AboutUsWrapper>
		</Container>
	);
};

export default AboutUs;
